// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","outline":"Button_outline__B6Yol","text":"Button_text__7U-98"};